import * as Sentry from '@sentry/react';
import type { SeverityLevel } from '@sentry/react';

type Primitive = string | number | boolean | null | undefined;

export interface SentryTraceContext {
  level?: SeverityLevel;
  tags?: Record<string, Primitive>;
  extra?: Record<string, unknown>;
}

/**
 * Trace « tout s'est bien passé » : un breadcrumb, pas un event.
 *
 * Même signature que `Sentry.captureMessage(message, context)` pour qu'un appel
 * se convertisse en changeant le nom de la fonction. Un breadcrumb ne coûte rien
 * dans le quota et accompagne la prochaine erreur réelle de la session (jusqu'à
 * 100 par event), là où un captureMessage par réservation ou par connexion
 * créait un event facturé à chaque fois (« Class booking successful » : 96 000
 * events sur l'ancien Sentry, sans un seul signal actionnable).
 */
export function sentryTrace(message: string, context: SentryTraceContext = {}): void {
  const { level = 'info', tags, extra } = context;
  const category = (tags?.category ?? tags?.flow ?? 'app') as string;
  Sentry.addBreadcrumb({
    category,
    message,
    level,
    data: { ...(tags ?? {}), ...(extra ?? {}) },
  });
}
